export const EngineType = [
  { type: "Petrol", id: 1 },
  { type: "Diesel", id: 2 },
];

export const TransmissionType = [
  { type: "Manual", id: 1 },
  { type: "Automatic", id: 2 },
];

export const Brands = [
  { brand: "Toyota", id: 1 },
  { brand: "Hyndai", id: 2 },
  { brand: "Honda", id: 3 },
  { brand: "Kia", id: 4 },
  { brand: "Land Rover", id: 5 },
  { brand: "Maruti Suzuki", id: 6 },
];

export const Model = [
  { brand: "i20", id: 1 },
  { brand: "i10", id: 2 },
  { brand: "i3", id: 3 },
  { brand: "Alto", id: 4 },
  { brand: "Alto k10", id: 5 },
  { brand: "Swift Dezire", id: 6 },
  { brand: "Swift", id: 7 },
];

export const CarTraveled = [
  { brand: "0-10000", id: 1 },
  { brand: "10000-20000", id: 2 },
  { brand: "20000-30000", id: 3 },
  { brand: "30000-40000", id: 4 },
  { brand: "40000-50000", id: 5 },
  { brand: "50000-60000", id: 6 },
  { brand: "60000-70000", id: 7 },
  { brand: "70000-80000", id: 8 },
  { brand: "80000-90000", id: 9 },
  { brand: "9000-100000", id: 10 },
  { brand: "100+", id: 11 },
];
